export const OPTIONS_FREQUENCY = [
	{ label: 'Daily', value: 'date' },
	{ label: 'Weekly (Mondays)', value: 'week' },
	{ label: 'Execute Now', value: 'now' }
]

export const OPTIONS_CONDITIONS = [
	{ label: 'All Changes', value: -1 },
	{ label: 'Changes +/- 5%', value: 5 },
	{ label: 'Changes +/- 10%', value: 10 },
	{ label: 'Changes +/- 15%', value: 15 },
	{ label: 'Changes +/- 20%', value: 20 },
    { label: 'Changes > 20%', value: 21 },
]